export default __webpack_public_path__ + "bf923bc9884e14f4968cab844eef82d5.svg";